import { useCallback } from 'react';

import { Button } from 'primereact/button';

import { useToggleImportantMutation } from '@/app/services/issues';

type ToggleImportantProps = {
  isImportant: boolean;
  requestId: number;
};

export const ToggleImportantButton = ({
  isImportant,
  requestId,
}: ToggleImportantProps) => {
  const [toggleImportant, { isLoading }] = useToggleImportantMutation();

  const handleToggleImportant = useCallback(() => {
    toggleImportant({
      id: requestId,
    });
  }, [toggleImportant, requestId]);

  return (
    <Button
      icon={isImportant ? 'pi pi-star-fill' : 'pi pi-star'}
      label="Important"
      severity="secondary"
      className="subscription-button"
      onClick={handleToggleImportant}
      disabled={isLoading}
    />
  );
};
